"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalActionButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ActionButton = require("../styled/ActionButton");
const ModalActionButton = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    content,
    onClick,
    "aria-label": ariaLabel,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_ActionButton.StyledActionButton, (0, _extends2.default)({
    onClick: onClick,
    appearance: "secondary-empty",
    type: "button",
    size: "medium",
    "aria-label": ariaLabel,
    iconBefore: typeof content !== "string" ? content : undefined,
    ref: ref
  }, props), typeof content === "string" ? content : undefined);
});
exports.ModalActionButton = ModalActionButton;
ModalActionButton.displayName = "ModalActionButton";
//# sourceMappingURL=ModalActionButton.js.map